/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useState } from 'react'
import { Link } from 'react-router'
// import { Theme, useTheme } from 'remix-themes'
// import { cn } from '~/lib/utils'

import UohLogoFooter from '../icons/uoh_logo_footer'
import SquareArrowUp from '../Header/icons/square-arrow-icon'
import SocialButtons from '~/components/UI/Buttons/SocialButtons/SocialButtons'
import { isDevelopment } from '~/utils/misc'

type FooterProps = {
  content: {
    links: any
    socialLinks: any
    smallLinks: any
  }
}

const Footer = ({ content }: FooterProps) => {
  const { links, socialLinks, smallLinks } = content

  // const [theme, setTheme] = useTheme()
  // const [themeSelect, setThemeSelect] = useState('light')

  return (
    <footer className='bg-blue-d'>
      <div className='relative container flex justify-end text-center text-white'>
        <button
          className='unstyled-link tag bg-blue-d-60 px-xs py-2xs-plus gap-xs absolute -top-[34px] z-10 hidden w-fit cursor-pointer items-center transition-all duration-300 sm:flex'
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }
        >
          <span>Back to top</span>{' '}
          <SquareArrowUp fill='white' width='22' height='22' strokewidth={4} />
        </button>
      </div>
      <div className='h-2xs-plus w-full overflow-hidden'>
        <img
          src='https://preview-websitemodern-uni-hull.cloud.contensis.com/image-library/textures/technical/UoH-Texture-Technical-01.png?crop=1920,20,center&q=75&f=webp'
          alt=''
          className='h-full w-full object-cover'
          height={20}
          width={1920}
          loading='lazy'
          role='presentation'
        />
      </div>
      <div className='divide-opacity-20 py-xs sm:py-m divide-blue-d-40 container grid grid-rows-subgrid divide-y-[1px] text-white'>
        <div className='py-m gap-m flex flex-wrap justify-between sm:items-end'>
          <div className='grow'>
            <div className='gap-m flex'>
              <Link
                to={`/${isDevelopment ? '?nodeId=7dbfda4f-5ffc-4a4f-883f-43dc4eb00222&entryId=7893812d-1bab-44e7-a1a4-45f07b924de3' : ''}`}
                aria-label='University of Hull homepage'
                className='unstyled-link shrink-0'
                reloadDocument
              >
                <UohLogoFooter fill={'white'} className={'h-2xl w-auto'} />
              </Link>
              <div className='py-2xs flex flex-col justify-between'>
                <p>Cottingham Road, Hull, HU6 7RX, United Kingdom</p>
                <p>
                  <Link to={'tel:+441482346311'}>+44 (0)1482 346311</Link>
                </p>
              </div>
            </div>
          </div>
          <div className='pl-2xl ml-xs-plus pb-3xs xl:ml-0 xl:pl-0'>
            <ul className='gap-m pb-2xs flex list-none flex-col flex-wrap pl-0 sm:flex-row'>
              {links.map((link: any, index: Index) => (
                <li key={index} className='text-nowrap'>
                  <Link to={link.entry?.sys.uri} reloadDocument>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className='py-m gap-m flex flex-row flex-wrap sm:items-center sm:justify-between'>
          <div className='grow'>
            <div className='gap-s flex h-full list-none items-center pl-0'>
              <SocialButtons
                content={{
                  buttons: socialLinks,
                  path: '/site-elements/icons/social/footer/',
                  hoverPath: '/site-elements/icons/social/'
                }}
                className='sm:size-l not-last:mr-2xs sm:p-2xs flex size-[40px] items-center justify-center'
              />
            </div>
          </div>
          {/* <div className='flex list-none pl-0'>
            <button
              className={cn(
                // theme === 'light' ? 'bg-white' : '',
                themeSelect === 'light' ? 'bg-white' : '',
                'p-xs appearance-none'
              )}
              // onClick={() => setTheme(Theme.LIGHT)}
              onClick={() => setThemeSelect('light')}
              title='Set light theme'
            >
              <span className='sr-only'>Set light theme</span>
              <img
                src={`https://preview-websitemodern-uni-hull.cloud.contensis.com/site-elements/icons/single-colour/${themeSelect === 'light' ? 'ink-blue' : 'white'}/sun.svg`}
                alt=''
                className='size-s'
              />
            </button>

            <button
              className={cn(
                // ttheme === 'dark' ? 'bg-white' : '',
                themeSelect === 'dark' ? 'bg-white' : '',
                'p-xs appearance-none'
              )}
              // onClick={() => setTheme(Theme.DARK)}
              onClick={() => setThemeSelect('dark')}
              title='Set dark theme'
            >
              <span className='sr-only'>Set dark theme</span>
              <img
                src={`https://preview-websitemodern-uni-hull.cloud.contensis.com/site-elements/icons/single-colour/${themeSelect === 'dark' ? 'ink-blue' : 'white'}/moon.svg`}
                alt=''
                className='size-s'
              />
            </button>
          </div> */}
        </div>

        <div className='py-m gap-m flex flex-wrap items-baseline justify-between'>
          <div className='grow'>
            <ul className='gap-xs sm:gap-m flex list-none flex-row flex-wrap pl-0'>
              {smallLinks.map((link: any, index: Index) => (
                <li key={index} className='text-nowrap'>
                  <Link
                    className='text-[12px]'
                    to={link.entry?.sys.uri}
                    reloadDocument
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className='inline-flex grow justify-end text-[12px]'>
            @ University of Hull, {new Date().getFullYear()}{' '}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
